export default "__VITE_ASSET__CZWy3rQ4__"